import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export const getRoomData = createAsyncThunk(
  'activity/th_room_data',
  async (e, store: any) => {
    const resp = await http.post('/live/activity/th_room_data', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)
export const getTopRankList = createAsyncThunk(
  'activity/th_room_rank',
  async (e, store: any) => {
    const resp = await http.post('/live/activity/th_room_rank', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)
export const getMore = createAsyncThunk(
  'activity/th_rank_more',
  async (e: any, store: any) => {
    const resp = await http.post('/live/activity/th_rank_more', {
      ...store.getState().env.deviceinfo,
      ...e,
    })
    return resp.data
  }
)

const initialState: {
  roomdata: {
    activity_expire: number
    room_uv: number
    room_income: number
    room_reward_info: Array<{
      reward_nos: Array<number>
      rewards: Array<number>
    }>
    err_msg: string
  }
  todayExpire: number
  today: {
    offset: number
    more: boolean
    list: Array<{
      room_id: number
      union_id: number
      union_name: string
      rank: number
      score: number
      avatar: string
    }>
  }
  yesterday: {
    offset: number
    more: boolean
    list: Array<{
      union_id: number
      union_name: string
      rank: number
      score: number
      avatar: string
      room_id: number
    }>
  }
} = {
  roomdata: {
    activity_expire: 0,
    room_uv: 0,
    room_income: 0,
    err_msg: '',
    room_reward_info: null,
  },
  todayExpire: 0,
  today: {
    offset: 0,
    more: true,
    list: [],
  },
  yesterday: {
    offset: 0,
    more: true,
    list: [],
  },
}

export const unionBattleASlice = createSlice({
  name: 'rankTask',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getRoomData.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, {roomdata: data})
    })
    builder.addCase(getTopRankList.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, data)
    })
    builder.addCase(getMore.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      const {period, list, more, offset} = data
      const keyName = ['today', 'yesterday'][period - 1]
      const currentList = state[keyName].list
      const newList = (list && currentList.concat(list)) || currentList
      Object.assign(state, {
        [keyName]: {list: newList, more, offset},
      })
    })
  },
})
export default unionBattleASlice.reducer
